import { ConnectError } from "@connectrpc/connect";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";

/** Trailer donde el servidor manda el código corto del error (ver
 *  `ClienteFincaWizardGrpcService.cs`, `CodeError`). */
const WIZARD_ERROR_CODE_TRAILER = "wizard-error-code";

/** Traduce un error de gRPC-Web de `ClienteFincaWizardService` al mismo shape
 *  JSON `{ success: false, code, message }` que ya arma el servidor para REST
 *  (`BadRequestCodeException`) y que ya sabe leer `parseWizardErrorMessage`/
 *  `parseWizardError` — así ninguno de esos parsers ni las 3 pantallas del
 *  wizard (`RegistroFincaPaso1Render`/`Paso3Render`/`Paso6Render`) necesitan
 *  enterarse de que el transporte cambió. Mismo patrón que
 *  `mapPasswordResetGrpcError` (login/password-reset), ver CLAUDE.md del
 *  Server, sección migración a gRPC-Web.
 *
 *  A diferencia de Login/PasswordReset este dominio requiere sesión, así que
 *  puede fallar por motivos que no son de este contrato (token vencido →
 *  `Code.Unauthenticated`, etc.) — esos no traen el trailer y se delegan a
 *  `mapConnectError` (misma jerarquía de errores que ya usa el resto de la
 *  app) en vez de mostrar el texto crudo de gRPC. */
export function mapFincaWizardGrpcError(error: unknown): Error {
  if (!(error instanceof ConnectError)) {
    return new Error("Error de red. Verifica tu conexión a internet.");
  }

  const code = error.metadata.get(WIZARD_ERROR_CODE_TRAILER);
  if (!code) {
    return mapConnectError(error);
  }

  return new Error(
    JSON.stringify({
      success: false,
      code,
      message: error.rawMessage,
    }),
  );
}
